import CalendarApi from 'web-app/api/calendar-api';
import PermissionsApi from 'web-app/api/permissions-api';
import PostApi from 'web-app/api/post-api';

export default {
    calendar: {
        getPossibleRecipients: CalendarApi.getPossibleRecipients,
    },
    permissions: {
        getPossibleRecipients: PermissionsApi.getPossibleRecipients,
    },
    post: {
        getPossibleRecipients: PostApi.getPossibleRecipients,
        getPossibleSenders: PostApi.getPossibleSenders,
    },
};
